import numberFormat from 'number-format.js/lib/format.es5';
import replaceAll from '../common/replaceAll';
const CURRENCY_PATTERNS = {
    CURRENCY_SYMBOL: '{currencySymbol}',
    DECIMAL_SEPARATOR: '{decimalSeparator}',
    GROUPING_SEPARATOR: '{groupingSeparator}',
    MINUS_SIGN: '-',
};
const DEFAULT_CURRENCY_FORMAT = '#,##0.00';
const UNIQUE_CURRENCY_SYMBOL = '¤';
const formatCurrency = (getFormatters) => (amount = 0) => {
    const formattingPatterns = getFormatters();
    const currencyPatterns = formattingPatterns.priceFormatter || {};
    const currencyFormat = (amount && amount < 0 && currencyPatterns
        ? currencyPatterns.patternNegatives
        : currencyPatterns.patternPositives) || DEFAULT_CURRENCY_FORMAT;
    /*
        When only one symbol is supplied, the numberFormat library will always treat that symbol
        as a decimal separator. If there is no decimal separator in the priceFormatter pattern,
        a symbol (e.g. ".") has to be added after the last zero to instruct the library to
        round the amount (if needed) and display it without any decimals.
    */
    const addDotAfterLastZero = (string) => {
        const dotPosition = string.lastIndexOf('0') + 1;
        const head = string.slice(0, dotPosition);
        const tail = string.slice(dotPosition);
        return `${head}.${tail}`;
    };
    const currencyFormatWithSeparators = replaceAll(currencyFormat.includes(CURRENCY_PATTERNS.DECIMAL_SEPARATOR)
        ? currencyFormat
        : addDotAfterLastZero(currencyFormat), {
        /*
         * numberFormat :: https://github.com/Mottie/javascript-number-formatter
         * - "The prefix or suffix can not include any numbers (0-9), dashes (-), or plus signs (+)."
         *
         * The numberFormat library don't support numbers as prefix or suffix and the russian
         * currency руб will not work as expected.
         *
         * We exchange the currency symbol with a unique symbol before the numberFormat and add it back to the result.
         * */
        [CURRENCY_PATTERNS.CURRENCY_SYMBOL]: UNIQUE_CURRENCY_SYMBOL,
        [CURRENCY_PATTERNS.DECIMAL_SEPARATOR]: currencyPatterns.decimalSeparator || '',
        [CURRENCY_PATTERNS.GROUPING_SEPARATOR]: currencyPatterns.groupingSeparator || '',
    });
    const formattedCurrency = numberFormat(currencyFormatWithSeparators.replace(CURRENCY_PATTERNS.MINUS_SIGN, ''), amount, {
        enforceMaskSign: true,
    }).replace(UNIQUE_CURRENCY_SYMBOL, currencyPatterns.currencySymbol);
    /*
        The numberFormat library doesn't handle the scenario when the currency symbol is positioned
        as prefix but after the minus sign, i.e. the pattern doesn't start or end with the currency symbol.
        Example: -{currencySymbol} #{groupingSeparator}##0
        By removing the minus sign before formatting and then re-adding it at the correct position
        after formatting, it will work correctly.
    */
    const minusSignPosition = currencyFormatWithSeparators.indexOf(CURRENCY_PATTERNS.MINUS_SIGN);
    return minusSignPosition >= 0
        ? `${formattedCurrency.slice(0, minusSignPosition)}${CURRENCY_PATTERNS.MINUS_SIGN}${formattedCurrency.slice(minusSignPosition)}`
        : formattedCurrency;
};
export default formatCurrency;
//# sourceMappingURL=formatCurrency.js.map